export const dwollaPasswordValidation =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[#?!@$%^&*-])[A-Za-z\d#?!@$%^&*-]{11,}$/;
export const passwordValidation =
  /.*([0-9]|[!"#$%&'()*+,-./:;<=>?@^_`{|}~]).*$/;

export const dwollaInvalidPasswordMessage =
  'Password must be at least 12 characters and contain a number, a letter, at least one of the special characters #?!@$%^&*- and no other special characters.';
